import { render, staticRenderFns } from "./m_Index.vue?vue&type=template&id=0db22332&scoped=true&"
import script from "./m_Index.vue?vue&type=script&lang=js&"
export * from "./m_Index.vue?vue&type=script&lang=js&"
import style0 from "./m_Index.vue?vue&type=style&index=0&id=0db22332&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db22332",
  null
  
)

export default component.exports